// @flow

import * as React from 'react';
import { createFragmentContainer, graphql } from 'react-relay/compat';
import AgentBadge from 'app/components/AgentBadge';
import JobEvent from '../JobEvent';
import type { JobEventStarted_event } from './__generated__/JobEventStarted_event.graphql';

type Props = {
  event: JobEventStarted_event,
  previousTimestamp: ?string
};

function JobEventStarted({ event: { timestamp, actor: { node: agent } }, previousTimestamp }: Props) {
  if (!agent) {
    return null;
  }

  return (
    <JobEvent timestamp={timestamp} previousTimestamp={previousTimestamp}>
      <JobEvent.Label>
        <AgentBadge agent={agent} /> Started Running Job
      </JobEvent.Label>
    </JobEvent>
  );
}

export default createFragmentContainer(JobEventStarted, {
  event: graphql`
    fragment JobEventStarted_event on JobEvent {
      timestamp
      actor {
        node {
          ...AgentBadge_agent
        }
      }
    }
  `
});

